import { MenuItem } from "@mui/material";
import { ChangeEvent, ReactElement } from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

import Select, { BaseSelectProps } from "../FormSelect";

enum BOOL_IN_TEXT {
  "TRUE" = "True",
  "FALSE" = "False",
  "None" = "",
}

export function RhfYesNoSelect<T extends FieldValues>(
  props: BaseSelectProps &
    UseControllerProps<T> & {
      multiple?: boolean;
      bottomLabel?: string;
    } & { defaultOption?: boolean | null }
): ReactElement {
  const {
    control,
    rules,
    shouldUnregister,
    name,
    defaultOption,
    ...selectProps
  } = props;
  const { field, fieldState } = useController({
    control,
    rules,
    shouldUnregister,
    name,
  });

  const coreParams = {
    onBlur: field.onBlur,
    name: field.name,
    error: Boolean(fieldState.error),
    inputRef: field.ref,
    helperText: fieldState.error ? fieldState.error.message : props.bottomLabel,
  };

  const displayValue = (value: boolean | null): string => {
    if (value === undefined || value === null) {
      return "";
    }
    return value ? BOOL_IN_TEXT.TRUE : BOOL_IN_TEXT.FALSE;
  };

  const onSelect = (value: string): boolean | null => {
    if (value === "") {
      return null;
    }
    return value === BOOL_IN_TEXT.TRUE;
  };

  return (
    <Select
      {...coreParams}
      {...selectProps}
      withNoneOption
      fullWidth
      onChange={(event: ChangeEvent<{ value: string }>) => {
        field.onChange(onSelect(event.target.value));
      }}
      value={displayValue(field.value)}
      renderValue={v => <>{v}</>}
    >
      <MenuItem key={BOOL_IN_TEXT.TRUE} value={BOOL_IN_TEXT.TRUE}>
        {BOOL_IN_TEXT.TRUE} {defaultOption && " (default)"}
      </MenuItem>
      <MenuItem key={BOOL_IN_TEXT.FALSE} value={BOOL_IN_TEXT.FALSE}>
        {BOOL_IN_TEXT.FALSE}
        {defaultOption === false && " (default)"}
      </MenuItem>
    </Select>
  );
}
